module.exports = __webpack_public_path__ + "static/media/operate.80c5dd6d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/operate.svg
// module id = 21
// module chunks = 1